import React, { useState } from "react";
import "./App.css";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Hamburger and close path data
  const hamburgerPath = "M3 7h18M3 12h18M3 17h18";
  const closePath = "M6 6L18 18M6 18L18 6";

  // For a smooth morph, interpolate between the two paths using CSS
  // We'll use two <path> elements and crossfade them

  return (
    <div className="App">
      <header className="custom-header">
        <div className="header-left">
          <img
            src={"/images/smetoolkitxnysc_saed_logo.png"}
            className="header-logo"
            alt="Logo 1"
          />
        </div>
        
        <button className={`header-btn ${menuOpen ? " active" : ""}`}>
          Get Started
          <span className="arrow-icon">
            <svg
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                stroke="#F5F5F5"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>
        <button
          className={`menu-btn ${menuOpen ? " close" : ""}`}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
            <path
              className="menu-morph-path hamburger"
              d="M1 7H13M1 1H19M1 13H19"
              stroke="#170F00"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ opacity: menuOpen ? 0 : 1, transition: 'opacity 0.3s cubic-bezier(0.4,0,0.2,1)' }}
            />
            <path
              className="menu-morph-path close"
              d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
              fill="#1D1B20"
              style={{ opacity: menuOpen ? 1 : 0, transition: 'opacity 0.3s cubic-bezier(0.4,0,0.2,1)' }}
            />
          </svg>
        </button>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-row hero-row-1">
          <h1 className="hero-header">
            Empowering Corps Members to Build Sustainable Businesses.
          </h1>
          <p className="hero-subheader">
            Access tools, mentorship, and opportunities to turn your NYSC year
            into the launchpad for your entrepreneurial journey.
          </p>
          <button className="header-btn">
            Get Started
            <span className="arrow-icon">
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                  stroke="#F5F5F5"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>
        </div>
        <div className="hero-row hero-row-2">
          <img
            src="/images/hero-image.png"
            alt="SMEToolkit Hero"
            className="hero-image"
          />
        </div>
      </section>

      {/* Feature Section */}
      <section className="feature-section">
        <div className="feature-header">
          <h2 className="feature-title">
            Everything You Need to Start, Run, and Grow
          </h2>
          <p className="feature-subtitle">
            Access practical tools, expert guidance and resources designed to
            help you turn ideas into thriving, sustainable businesses.
          </p>
        </div>
        <div className="feature-section-img">
          <svg
            width="249"
            height="188"
            viewBox="0 0 249 188"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M604.2 -255.966C524.667 -251.784 373.631 -181.126 405.752 68.0398C449.131 196.702 585.623 -66.7485 321.514 -14.3062C110.226 27.6476 39.138 123.215 30.0049 165.754"
              stroke="#069006"
              stroke-width="5.24131"
              stroke-dasharray="23.69 23.69"
            />
            <path
              d="M28.4881 170.538C24.9492 172.073 21.0205 169.388 21.1646 165.533L22.0323 142.327C22.1864 138.205 26.8213 135.868 30.227 138.196L50.6636 152.16C54.0693 154.487 53.5765 159.655 49.7923 161.296L28.4881 170.538Z"
              fill="#069006"
            />
          </svg>
        </div>
        <div className="feature-grid">
          {/* Feature Card 1 */}
          <div className="feature-card feature-bg-1">
            <div className="feature-card-content">
              <h3 className="feature-card-title">Learning Hub</h3>
              <p className="feature-card-desc">
                Gain access to expert-led courses in business management,
                marketing, finance, and digital tools certificates that matter.
              </p>
              <a href="https://nysc.learnwithedcpau.com/" target="_blank" rel="noopener noreferrer">
                <button className="feature-card-btn">
                  Get Started
                  <span className="arrow-icon">
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </a>
            </div>
            <div className="feature-card-icon">
              <img src="/images/learning-hub.png" alt="Learning Hub Icon" />
            </div>
          </div>
          {/* Feature Card 2 */}
          <div className="feature-card feature-bg-2">
            <div className="feature-card-content">
              <h3 className="feature-card-title">Growth Plan</h3>
              <p className="feature-card-desc">
                Build your business roadmap with our milestone-based plan
                builder a tool that helps you stay organized, accountable, and
                ready for funding.
              </p>
              <a href="https://www.learnwithedcpau.com/growth-plan" target="_blank" rel="noopener noreferrer">
                <button className="feature-card-btn">
                  Get Started
                  <span className="arrow-icon">
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </a>
            </div>
            <div className="feature-card-icon">
              <img src="/images/growth-plan.png" alt="Growth Plan Icon" />
            </div>
          </div>
          {/* Feature Card 3 */}
          <div className="feature-card feature-bg-3">
            <div className="feature-card-content">
              <h3 className="feature-card-title">Mentorship (BDSP)</h3>
              <p className="feature-card-desc">
                Get personalized guidance from seasoned Nigerian entrepreneurs
                and business professionals who help you refine your ideas,
                develop viable business models, and navigate real-world
                challenges with confidence.
              </p>
              <a href="https://edcmentorship.com" target="_blank" rel="noopener noreferrer">
                <button className="feature-card-btn">
                  Get Started
                  <span className="arrow-icon">
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </a>
            </div>
            <div className="feature-card-icon">
              <img src="/images/mentorship.png" alt="Learning Hub Icon" />
            </div>
          </div>

          <div className="feature-card feature-bg-8">
            <div className="feature-card-content">
              <h3 className="feature-card-title">Smart Business News</h3>
              <p className="feature-card-desc">
                Get curated business news, insights, and trends to help you make
                informed decisions and grow faster.
              </p>
              <a href="https://smetoolkit.ng/articles" target="_blank" rel="noopener noreferrer">
              <button className="feature-card-btn">
                Get Started
                <span className="arrow-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              </a>
            </div>
            <div className="feature-card-icon">
              <img
                src="/images/smartbuiness-news.png"
                alt="Learning Hub Icon"
              />
            </div>
          </div>
          {/* Feature Card 4 */}
          <div className="feature-card feature-bg-4">
            <div className="feature-card-content">
              <h3 className="feature-card-title">
                AI-Powered Business Advisor
              </h3>
              <p className="feature-card-desc">
                Get instant, 24/7 access to personalized business guidance and
                data-driven insights anytime. Analyze your progress, and make
                smarter business decisions.
              </p>
              <button className="feature-card-btn">
                Get Started
                <span className="arrow-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="feature-card-icon">
              <img
                src="/images/ai-powered-business.png"
                alt="Learning Hub Icon"
              />
            </div>
          </div>
          <div className="feature-card feature-bg-5">
            <div className="feature-card-content">
              <h3 className="feature-card-title">Marketplace Access</h3>
              <p className="feature-card-desc">
                Gain access to expert-led courses in business management,
                marketing, finance, and digital tools certificates that matter.
              </p>
              <button className="feature-card-btn">
                Get Started
                <span className="arrow-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="feature-card-icon">
              <img src="/images/marketplace-icon.png" alt="Learning Hub Icon" />
            </div>
          </div>
          <div className="feature-card feature-bg-6">
            <div className="feature-card-content">
              <h3 className="feature-card-title">Funding and Market Access</h3>
              <p className="feature-card-desc">
                Explore regularly updated funding programs, grants, and investor
                networks that help corps members take their ventures to the next
                level.
              </p>
              <button className="feature-card-btn">
                Get Started
                <span className="arrow-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="feature-card-icon">
              <img
                src="/images/funding-market-access.png"
                alt="Learning Hub Icon"
              />
            </div>
          </div>
          <div className="feature-card feature-bg-7">
            <div className="feature-card-content">
              <h3 className="feature-card-title">
                Professional Business Tools
              </h3>
              <p className="feature-card-desc">
                Access CRM, invoicing, project management, and other
                productivity tools powered by CREDO to run your business like a
                pro.
              </p>
              <button className="feature-card-btn">
                Get Started
                <span className="arrow-icon">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.8335 8.00016H13.1668M13.1668 8.00016L8.50016 3.3335M13.1668 8.00016L8.50016 12.6668"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="feature-card-icon">
              <img
                src="/images/professional-business-tools.png"
                alt="Learning Hub Icon"
              />
            </div>
          </div>
          
        </div>
      </section>

      {/* Why Choose SMEToolkit Section */}
      <section className="whychoose-section">
        <h2 className="whychoose-title">Why Choose SMEToolkit</h2>
        <div className="whychoose-row">
          <div className="whychoose-img-col">
            <img
              src="/images/why-chose-us.jpg"
              alt="Why Choose Us"
              className="whychoose-img"
            />
          </div>
          <div className="whychoose-features-col">
            <div className="whychoose-feature">
              <h3 className="whychoose-feature-title">Learn by Doing</h3>
              <p className="whychoose-feature-desc">
                We don’t just teach, we equip. From day one, you’ll access
                hands-on business courses, practical tools, and real-world
                challenges that prepare you to build and grow your own venture.
              </p>
            </div>
            <div className="whychoose-feature">
              <h3 className="whychoose-feature-title">
                A Community That Cares
              </h3>
              <p className="whychoose-feature-desc">
                You’re not in this alone. Join a vibrant network of mentors,
                fellow corps members, and business leaders who support your
                entrepreneurial journey even beyond your service year.
              </p>
            </div>
            <div className="whychoose-feature">
              <h3 className="whychoose-feature-title">Start from Zero</h3>
              <p className="whychoose-feature-desc">
                No prior business experience? No problem. Our platform is built
                for beginners, dreamers, and changemakers ready to turn ideas
                into impact.
              </p>
            </div>
            <div className="whychoose-feature">
              <h3 className="whychoose-feature-title">
                Get Recognized and Respected.
              </h3>
              <p className="whychoose-feature-desc">
                Earn certifications that prove your skills and boost your
                credibility. Whether you’re applying for funding, pitching
                investors, or launching your business your growth here gets
                noticed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer-section">
        <div className="footer-content">
          &copy; 2025 SMEToolkit. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
